import React, { useEffect, useState } from "react";
import Images from "../../../Images";
import {
  CombineInputGroup,
  FieldWrappers,
  InputGroup,
  Label,
  SubmitBtn,
} from "../../../Components/Styles/InputStyles";
import * as Yup from "yup";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import { useFormik } from "formik";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getYear, getMonth } from "date-fns";
import { FaRegCalendar } from "react-icons/fa";
import "react-datepicker/dist/react-datepicker.css";
export default function PersonalDetails({
  tenantData,
  setSelectedData,
  editPersonalDetailMutate,
  isPersonalDetailLoading,
  e
}
) {

  const [data, setData] = useState(tenantData);
  const [calendarOpen, setCalendarOpen] = useState(false);
  useEffect(() => {
    setData(tenantData);
  }, [tenantData]);

  const personalFormik = useFormik({
    initialValues: {
      name: tenantData?.name || "",
      mobile: tenantData?.mobile || "",
      email: tenantData?.email || "",
      gender: tenantData?.gender ? String(tenantData?.gender) : "",
      //occupation: tenantData?.occupation === 'Professional' ? '2' : tenantData?.occupation === 'Student' ? '1' : tenantData?.occupation,
      dob: tenantData?.dob ? moment(tenantData?.dob).format("YYYY-MM-DD") : "",
      address: tenantData?.address || "",
      //currentAddress: tenantData?.currentAddress || "",
      nationality: tenantData?.nationality || "Indian",
      alternateMobile: tenantData?.alternateMobile || "",
      monthlyIncome: tenantData?.monthlyIncome || "",
      bloodGroup: tenantData?.bloodGroup || "",
    },

    onSubmit: (values) => {
      if (!values.name) {
        toast.error("Name is required");
        return;
      }
      if (!values.mobile) {
        toast.error("Mobile Number is required");
        return;
      }
      if (!/^\d{10}$/.test(values.mobile)) {
        toast.error("Mobile Number must be exactly 10 digits");
        return;
      }

      if (!values.gender) {
        toast.error("Gender is required");
        return;
      }

      editPersonalDetailMutate(values);
    },
    enableReinitialize: true,
  });

  const getInputClass = (isDisabled) => {
    return isDisabled
      ? "bg-gray-100 cursor-not-allowed" : "pl-2 relative rounded-md w-full flex items-center border border-gray-400 h-12";
  };

  const gender = [
    { label: "Male", value: 1 },
    { label: "Female", value: 2 },
    { label: "Others", value: 3 },
  ];

  return (
    <>
      <Wrapper>
        <Title>
          Personal Details
        </Title>
        <form
          onSubmit={personalFormik.handleSubmit}
          className="grid grid-cols-1 md:gap-4"
        >
          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="name">Tenant Name</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="name"
                  name="name"
                  className={getInputClass(false)}
                  value={personalFormik.values.name}
                  //onChange={personalFormik.handleChange}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^[a-zA-Z0-9. ]{0,50}$/.test(value)) {
                      personalFormik.setFieldValue("name", value);
                    }
                  }}
                  onBlur={personalFormik.handleBlur}
                />
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="mobile">Mobile</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="mobile"
                  name="mobile"
                  value={personalFormik.values.mobile}
                  className={getInputClass(false)}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) {
                      personalFormik.setFieldValue("mobile", value);
                    }
                  }}
                  onBlur={personalFormik.handleBlur}
                />
              </FieldWrapper>
            </InputGroup>

            <InputGroup>
              <Label htmlFor="email">Email</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="email"
                  name="email"
                  className={getInputClass(false)}
                  value={personalFormik.values.email}
                  onChange={personalFormik.handleChange}
                  onBlur={personalFormik.handleBlur}
                />
              </FieldWrapper>
            </InputGroup>
          </CombineInputGroup>

          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="gender">Gender</Label>
              <FieldWrapper>
                <Select
                  id="gender"
                  name="gender"
                  className="w-full pl-2"
                  value={personalFormik.values.gender}
                  onChange={personalFormik.handleChange}
                  onBlur={personalFormik.handleBlur}
                  style={{ height: "46px" }}
                  // displayEmpty
                  
                >
                  <MenuItem value=""disabled>
                    <span className="text-gray-400">Select gender</span>
                  </MenuItem>
                  {gender.map((item) =>(
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                  {/* <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                  <MenuItem value="Others">Others</MenuItem> */}
                </Select>
              </FieldWrapper>
            </InputGroup>

            <InputGroup>
              <Label htmlFor="bloodGroup">Blood Group</Label>
              <FieldWrapper>
                <Select
                  id="bloodGroup"
                  name="bloodGroup"
                  className="w-full pl-2"
                  value={personalFormik.values.bloodGroup}
                  onChange={personalFormik.handleChange}
                  onBlur={personalFormik.handleBlur}
                  style={{ height: "46px" }}
                >
                  <MenuItem value=""disabled>
                    <span className="text-gray-400">Select blood group</span>
                  </MenuItem>
                  <MenuItem value="1">A+</MenuItem>
                  <MenuItem value="2">A-</MenuItem>
                  <MenuItem value="3">B+</MenuItem>
                  <MenuItem value="4">B-</MenuItem>
                  <MenuItem value="5">AB+</MenuItem>
                  <MenuItem value="6">AB-</MenuItem>
                  <MenuItem value="7">O+</MenuItem>
                  <MenuItem value="8">O-</MenuItem>
                </Select>
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="dob">DOB</Label>
              <FieldWrappers className="relative border border-gray-400">

                <DatePicker
                  selected={personalFormik.values.dob}
                  showYearDropdown
                  yearDropdownItemNumber={70} // optional: number of years in dropdown
                  scrollableYearDropdown // optional: enables scrolling in dropdown
                  maxDate={new Date()}
                  onChange={(date) => {
                    personalFormik.setFieldValue("dob", moment(date).format("YYYY-MM-DD"));
                    setCalendarOpen(false);
                  }}
                  onBlur={personalFormik.handleBlur}
                  onClickOutside={() => setCalendarOpen(false)}
                  onSelect={() => setCalendarOpen(false)}
                  open={calendarOpen}
                  onInputClick={() => setCalendarOpen(true)}
                  dateFormat="yyyy-MM-dd"
                  className="cursor-pointer items-center"
                  placeholderText="YYYY-MM-DD"
                  showIcon
                  icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                  showPopperArrow={false}
                  onFocus={(e) => e.target.blur()}
                  wrapperClassName="w-full"
                  portalId="root-portal"
                  popperClassName="react-datepicker-popper"
                />
              </FieldWrappers>
            </InputGroup>

          </CombineInputGroup>

          <InputGroup>
            <Label htmlFor="address">Permanent Address</Label>
            <FieldWrapper>
              <Input
                type="text"
                id="address"
                name="address"
                className={getInputClass(false)}
                // numberOfLines={3}
                value={personalFormik.values.address}
                onChange={personalFormik.handleChange}
                onBlur={personalFormik.handleBlur}
              />
            </FieldWrapper>
          </InputGroup>
          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="nationality">Nationality</Label>
              <FieldWrapper>
                <Select
                  id="nationality"
                  name="nationality"
                  className="w-full pl-2"
                  value={personalFormik.values.nationality}
                  onChange={personalFormik.handleChange}
                  onBlur={personalFormik.handleBlur}
                  style={{ height: "46px" }}
                >
                  <MenuItem value=""disabled>
                    <span className="text-gray-400">Select nationality</span>
                  </MenuItem>
                  <MenuItem value="American">American</MenuItem>
                  <MenuItem value="Canadian">Canadian</MenuItem>
                  <MenuItem value="British">British</MenuItem>
                  <MenuItem value="Australian">Australian</MenuItem>
                  <MenuItem value="Indian">Indian</MenuItem>
                  <MenuItem value="Chinese">Chinese</MenuItem>
                  <MenuItem value="Japanese">Japanese</MenuItem>
                  <MenuItem value="German">German</MenuItem>
                  <MenuItem value="French">French</MenuItem>
                  <MenuItem value="Italian">Italian</MenuItem>
                  <MenuItem value="Russian">Russian</MenuItem>
                  <MenuItem value="Brazilian">Brazilian</MenuItem>
                  <MenuItem value="Mexican">Mexican</MenuItem>
                  <MenuItem value="South African">South African</MenuItem>
                  <MenuItem value="Spanish">Spanish</MenuItem>
                  <MenuItem value="Korean">Korean</MenuItem>
                  <MenuItem value="Argentinian">Argentinian</MenuItem>
                  <MenuItem value="Dutch">Dutch</MenuItem>
                  <MenuItem value="Swedish">Swedish</MenuItem>
                  <MenuItem value="Turkish">Turkish</MenuItem>
                </Select>
              </FieldWrapper>
            </InputGroup>

            <InputGroup>
              <Label htmlFor="alternateMobile">Alternate Mobile</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="alternateMobile"
                  name="alternateMobile"
                  className={getInputClass(false)}
                  value={personalFormik.values.alternateMobile}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) {
                      personalFormik.setFieldValue("alternateMobile", value);
                    }
                  }}
                  onBlur={personalFormik.handleBlur}
                />
              </FieldWrapper>
            </InputGroup>


          </CombineInputGroup>
          <BtnWrapper>
            <SubmitBtn type="submit"
              disabled={e ? true : isPersonalDetailLoading}
              className="text-sm  w-24  md:w-20 h-7 md:text-xs"
            >
              {isPersonalDetailLoading ? "Updating..." : "Update"}
            </SubmitBtn>
          </BtnWrapper>
        </form>

      </Wrapper>
    </>
  );
}

const Wrapper = tw.div`  space-y-4 mt-2`;
const Title = tw.h3`text-md md:text-md lg:text-md tracking-wider font-semibold pb-2 text-black`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const FieldWrapper = tw.div`w-full`;
//const FieldWrapper = tw.div`pl-2 relative rounded-md w-full flex items-center border border-gray-200 h-12`;
const BtnWrapper = tw.div`w-full flex items-center justify-end mt-4`;
